import React, { useEffect, FunctionComponent } from "react";
import styled from "styled-components";

import Device from "@/utils/device";
import StepForwardTitle from "../step-forward/StepForwardTitle";
import { CXL } from "@/components/Typography";
import { colours } from "@/utils";

const EventbriteWidget = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.eventbrite.co.uk/static/widgets/eb_widgets.js";
    script.async = true;

    document.body.appendChild(script);

    script.onload = () => {
      const exampleCallback = () => {
        console.log("Order complete!");
      };

      window.EBWidgets.createWidget({
        widgetType: "checkout",
        eventId: "1098859521409",
        iframeContainerId: "eventbrite-widget-container-1098859521409'",

        iframeContainerHeight: 425,
        onOrderComplete: exampleCallback,
      });
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <S.Widget id="eventbrite-widget-container-1098859521409'"></S.Widget>;
};

const TicketsContent: FunctionComponent = () => {
  return (
    <S.Section data-cy="SF-content-tickets" id="tickets-section">
      <S.CopyContainer>
        <StepForwardTitle>
          <S.FontWeightWrap>The </S.FontWeightWrap>
          <S.ItalicWrap>London</S.ItalicWrap> <br />
          Summit
        </StepForwardTitle>
        <CXL>
          <S.BoldWrap>Back and bigger than ever before!</S.BoldWrap> A full day
          of insightful discussions, one-of-a-kind experiences and panel talks
          on the issues that matter, from our world-class line-up of incredible
          speakers.
        </CXL>
      </S.CopyContainer>
      <S.WidgetContainer data-cy="eventbrite-widget">
        <EventbriteWidget />
      </S.WidgetContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  padding: 10%;
  background: ${colours.stepForwardLilac};
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media ${Device.tablet} {
    display: grid;
    padding: 5% 10%;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.5fr);
    grid-gap: 60px;
  }
`;

S.CopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media ${Device.mobile} {
    gap: 30px;
  }

  @media ${Device.desktop} {
    margin: 0 60px 0 0;
    gap: 40px;
  }
`;

S.FontWeightWrap = styled.span`
  font-weight: 100;
`;

S.ItalicWrap = styled.span`
  font-style: italic;
`;

S.BoldWrap = styled.span`
  font-weight: 700;
`;

S.WidgetContainer = styled.div`
  position: relative;
  width: 100%;
`;

S.Widget = styled.div`
  > * {
    border-radius: 5px;
  }
`;

S.PromoCallout = styled(CXL)`
  font-size: 24px;
`;

export default TicketsContent;
